module.exports = __webpack_public_path__ + "static/img/ad68f9b7e072414637a2ae1814eac45c.product2.1709800931122.png";